// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import * as DmsCommon from './../supports/dms-common';
import * as DmsService from './../supports/dms-service';
import FolderTreeList2 from './FolderTreeList2';
import { GlobalEvent, GlobalState } from './GlobalContext'
import MsgDialog from './MsgDialog';
import PropTypes from 'prop-types';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import SelMemberDialog from './SelMemberDialog';
import IconButton from '@mui/material/IconButton';
import GroupIcon from '@mui/icons-material/Group';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';

import dayjs from "dayjs"

import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-material.css';



export default function FolderAdminTab(props) {
  const { sysID, onUpdate } = props;

  // Get Global state and dispatcher
  const [gState, gStateDispatch] = React.useContext(GlobalState);

  const [gEvent, gEventDispatch] = React.useContext(GlobalEvent);

  const curDept = gState?.depts?.find(d => d.DeptCode == sysID);
  const adminLevel = curDept?.AdminLevel || 0;
  const isDataAdmin = ((adminLevel & DmsCommon.SystemAdminEnum.saData) == DmsCommon.SystemAdminEnum.saData);
  const isSecurtyAdmin = ((adminLevel & DmsCommon.SystemAdminEnum.saSecurity) == DmsCommon.SystemAdminEnum.saSecurity);

  const [showLoading, setShowLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  // const [folders, setFolders] = useState([]);
  // const [selFolderID, setSelFolderID] = useState(DmsCommon.VOID_FOLDER_ID)
  const [folderState, setFolderState] = useState({
    folders: [],
    selFolderID: DmsCommon.VOID_FOLDER_ID,
  });


  useEffect(() => {
    // console.log("useEffect FolderAdminTab(did mounted)");
    refreshData();
  }, []);


  const onCatchPromiseError = (e) => {
    gEventDispatch({
      showErr: true,
      err: e,
    });

  }

  const [isNormalFolder, setIsNormalFolder] = useState(false);
  const [selFolder, setSelFolder] = useState(null);

  const onFolderIDChange = async (aFolderID) => {
    // console.log("onFolderIDChange");

    const vIsNormalFolder = ![DmsCommon.VOID_FOLDER_ID, DmsCommon.ALL_FOLDER_ID, DmsCommon.PERSONAL_FOLDER_ID].includes(aFolderID);
    setIsNormalFolder(vIsNormalFolder);


    const vSelFolder = folderState.folders.find(f => f.id == aFolderID);
    setSelFolder(vSelFolder);

    setShowLoading(true);

    try {
      const vFolderAdmins = await DmsService.getFolderAdminPromise(gState.sessionID, sysID, aFolderID);
      // console.log("vFolderAdmins", vFolderAdmins);

      setShowLoading(false);

      const vData = vFolderAdmins.map(item => {

        return {
          ...item,
          // NameForDisplay: vDisplay,
          // GradeForDisplay: DmsCommon.AccessRightEnumToStr(item.Grade),
        }
      });

      setGridData(vData);


    } catch (e) {
      setShowLoading(false);

      // setErrMsg(e.errMsg || e.message);
      // setShowError(true);
      onCatchPromiseError(e);
    }
  }


  const refreshData = async (aSelFolderID) => {
    // console.log("FolderAdminTab refreshData");


    setShowLoading(true);

    try {
      const vRstFolders = await DmsService.logIfLongRunningGetFoldersPromise(gState.sessionID, sysID, true);
      // console.log("vRstFolders", vRstFolders);

      setShowLoading(false);

      // const vFolders = vRstFolders;
      const vFolders = vRstFolders.filter(item => {
        return (item.ParentID == DmsCommon.ALL_FOLDER_ID || item.ParentID == DmsCommon.PERSONAL_FOLDER_ID);
      })


      if (aSelFolderID) {
        setFolderState((prevState) => { return { ...prevState, folders: vFolders, selFolderID: aSelFolderID } });
      } else {
        setFolderState((prevState) => { return { ...prevState, folders: vFolders } });
      }

    } catch (e) {
      setShowLoading(false);

      setFolderState((prevState) => { return { ...prevState, folders: [] } });


      // console.log('Fail: ', e);

      // setErrMsg(e.errMsg || e.message);
      // setShowError(true);
      onCatchPromiseError(e);
    }


  }


  const handleChangeFolderID = (AFolderID) => {
    // console.log("handleChangeFolderID", AFolderID);

    setFolderState((prevState) => { return { ...prevState, selFolderID: AFolderID } });
    onFolderIDChange(AFolderID);
  }




  const [openAddUserDialog, setOpenAddUserDialog] = useState(false);
  const [members, setMembers] = useState([]);
  const [groups, setGroups] = useState([]);

  const handleAddByUser = async () => {

    setShowLoading(true);

    try {

      const [vUsers, vGroups] = await Promise.all([
        DmsService.getMembersPromise(gState.sessionID, sysID, false),
        DmsService.getGroupsPromise(gState.sessionID, sysID),
      ]);

      // console.log('vUsers', vUsers);
      // console.log('vGroups', vGroups);

      setShowLoading(false);

      setMembers(vUsers);
      setGroups(vGroups);

      setOpenAddUserDialog(true);
    } catch (e) {
      setShowLoading(false);
      // setErrMsg(e.errMsg || e.message);
      // setShowError(true);
      onCatchPromiseError(e);
    }


  };

  const handleSelectAddUsers = async (aUsers, aGroups) => {
    // console.log("aUsers", aUsers);
    // console.log("aGroups", aGroups);

    setOpenAddUserDialog(false);

    let vData = gridData.map(item => {
      return item
    });

    aUsers.forEach(addUser => {
      const vFound = vData.find(f => f.UserOrGroupID.toLowerCase() === addUser.UserID.toLowerCase());
      if (!vFound) {
        // console.log("addUser", addUser);
        const vNewItem = {
          "IsUser": true,
          "Name": addUser.FullName,
          "UserOrGroupID": addUser.UserID,
        }

        vData.push(vNewItem);

      }
    });

    aGroups.forEach(addGroup => {
      const vFound = vData.find(f => f.UserOrGroupID.toLowerCase() === addGroup.GroupID.toLowerCase());
      if (!vFound) {
        // console.log("addUser", addUser);
        const vNewItem = {
          "IsUser": false,
          "Name": addGroup.Name,
          "UserOrGroupID": addGroup.GroupID,
        }

        vData.push(vNewItem);

      }
    });

    // console.log("vData", vData);



    setShowLoading(true);
    try {

      const vIDList = vData.map(item => item.UserOrGroupID);
      // console.log("vIDList", vIDList);

      await DmsService.folderAdminUpdatePromise(gState.sessionID, sysID, selFolder?.id, vIDList);

      setShowLoading(false);

      setGridData(vData);

      onUpdate && onUpdate();

    } catch (e) {
      setShowLoading(false);

      // setErrMsg(e.errMsg || e.message);
      // setShowError(true);
      onCatchPromiseError(e);
    }

  }

  const [selectedRecs, setSelectedRecs] = useState([]);

  const onSelectionChanged = (params) => {
    // console.log('Selection Changed', params);
    let nodes = params.api.getSelectedNodes();
    // console.log('Selected nodes', nodes);

    let selRecs = nodes.map(item => {
      return item.data
    });

    setSelectedRecs(selRecs);

  }

  const handleRemove = async () => {
    // console.log("handleRemove selectedRecs", selectedRecs);

    const vData = gridData.filter(d => !selectedRecs.some(r => r.UserOrGroupID === d.UserOrGroupID));

    setShowLoading(true);
    try {

      const vIDList = vData.map(item => item.UserOrGroupID);
      // console.log("vIDList", vIDList);

      await DmsService.folderAdminUpdatePromise(gState.sessionID, sysID, selFolder?.id, vIDList);

      setShowLoading(false);

      setGridData(vData);
      setSelectedRecs([]);

      onUpdate && onUpdate();

    } catch (e) {
      setShowLoading(false);

      // setErrMsg(e.errMsg || e.message);
      // setShowError(true);
      onCatchPromiseError(e);

    }

  }

  const [gridData, setGridData] = useState([]);

  // const [openPermEditDialog, setOpenPermEditDialog] = useState(false);

  // const handleEditClick = () => {
  //   setOpenPermEditDialog(true);
  // }


  const cellStyle = { paddingLeft: '10px', paddingRight: '10px', fontSize: '0.8rem' };

  const handleGetRowId = useCallback((params) => params.data.UserOrGroupID, []);

  const UserTypeRenderer = (params) => {
    return (

      <IconButton color="primary" aria-label="upload picture" component="span">
        {params.value === true && <AccountCircleIcon />}
        {params.value !== true && <GroupIcon />}
      </IconButton>
    )
  }


  const compareStrInsensitive = (aStrA, aStrB) => {
    return aStrA.localeCompare(aStrB, undefined, { sensitivity: "base" })
  }

  const comparatorName = (a, b, nodeA, nodeB) => {
    return compareStrInsensitive(nodeA.data.Name, nodeB.data.Name)
  }


  const columnDefs = useMemo(() => [
    { field: 'IsUser', headerName: " ", cellStyle: cellStyle, width: 50, cellRenderer: UserTypeRenderer, },
    {
      field: 'Name', headerName: "Group/User Name", cellStyle: cellStyle, minWidth: 150, flex: "1",
      headerCheckboxSelection: true, checkboxSelection: true, comparator: comparatorName,
    },
  ], []);



  return (
    <Box sx={{
      display: 'flex', flexDirection: 'row',
      height: "65vh"
    }} >
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <MsgDialog
        open={showError}
        title="Error"
        msgText={errMsg}
        onClose={() => setShowError(false)}
      />


      <div className="ag-theme-material" style={{ width: '50%', height: '100%', bgcolor: 'yellow' }}>

        <Box sx={{ display: 'flex', p: 0, height: 1, maxHeight: 1, overflow: 'auto' }} >
          <FolderTreeList2
            folders={folderState.folders}
            selFolderID={folderState.selFolderID}
            onChangeFolderID={handleChangeFolderID}
            disableReadCnt

          />

        </Box>

      </div>

      <Box sx={{ display: isNormalFolder ? "block" : "none", width: 0.5, height: 1, m: 1 }} >
        <Box sx={{ py: 1, px: 1 }} >

          <Button startIcon={<PersonAddAlt1Icon />} disabled={!isNormalFolder || !selFolder}
            onClick={handleAddByUser} >
            Add
          </Button>
          <SelMemberDialog
            open={openAddUserDialog}
            onClose={() => { setOpenAddUserDialog(false) }}
            members={members}
            groups={groups}
            onSelect={handleSelectAddUsers}
          />

          <Button startIcon={<PersonRemoveIcon />} disabled={!isNormalFolder || !selFolder || selectedRecs.length <= 0} onClick={handleRemove} >
            Remove
          </Button>

        </Box>

        <Box sx={{ width: 1, height: 0.8 }} >

          <div className="ag-theme-material" style={{ width: '100%', height: '100%', }}>
            <AgGridReact

              rowData={gridData}

              defaultColDef={{
                width: 100,
                resizable: true,
                sortable: true,
                suppressMovable: true,
              }}
              columnDefs={columnDefs}
              headerHeight={40}

              suppressNoRowsOverlay

              rowSelection="multiple"
              rowMultiSelectWithClick

              onSelectionChanged={onSelectionChanged}

              getRowId={handleGetRowId}


            />
          </div>
        </Box>

      </Box>

    </Box>


  );
}

FolderAdminTab.propTypes = {
  sysID: PropTypes.string,
  onUpdate: PropTypes.func,
};
